// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"208":"d27bb861","878":"bfaa808c"}[chunkId] + ".chunk.js");